import React from "react";
import './c58_two_col_video_player.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import ReactPlayer from 'react-player'

class TwoColVideoPlayer extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            playing: false
        };
    };

    playVideo = () => {
        this.setState({
            isHidden: false,
            playing: true
        })
    }

    componentRender(data) {
        return (
            <div id={!isMobileOnly ? 'two-col-vp' : 'two-col-vp-mob'}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className={!isMobileOnly ? 'vp-video-container' : 'vp-video-container-mob'}>
                                <ReactPlayer url={data.video} ref={this.vidRef} controls={!this.state.isHidden} playing={this.state.playing}/>
                                {this.state.isHidden && <img src={data.image} className="vp-button-image" alt={'Luiss.it'}/>}
                                {this.state.isHidden &&
                                        <button className="vp-button"
                                        onClick={this.playVideo.bind(this)}>
                                            <div className="card-video-triangle" />
                                            <div className="vp-button-shadow" />
                                        </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TwoColVideoPlayer;
